(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-lux"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var timers = document.querySelectorAll('.mr-countdown-timer[data-countdown-target]');
  if (!timers.length) return;

  function pad(num) {
    return num < 10 ? '0' + num : String(num);
  }

  timers.forEach(function(timer) {
    var targetRaw = timer.getAttribute('data-countdown-target');
    if (!targetRaw) return;

    var targetDate = new Date(targetRaw);
    if (isNaN(targetDate.getTime())) {
      console.warn('Compte à rebours Maison Rollet : date invalide →', targetRaw);
      return;
    }

    var daysEl = timer.querySelector('.mr-days');
    var hoursEl = timer.querySelector('.mr-hours');
    var minutesEl = timer.querySelector('.mr-minutes');
    var secondsEl = timer.querySelector('.mr-seconds');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    function tick() {
      var now = new Date();
      var diff = targetDate.getTime() - now.getTime();

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / (60 * 60 * 24));
      var hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      var minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-text"] && !Shopify.designMode) return;
  try {
    

 var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    };

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
              new TxtType(elements[i], JSON.parse(toRotate), period);
            }
        }
        // INJECT CSS
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
        document.body.appendChild(css);
    };


  } catch(e) { console.error(e); }
})();
})();
